<!-- loader.component.html -->
<div class="overlay-loading" [class.show-loading]="loading | async" >
    <mat-spinner class="spinner-loading"  mode="indeterminate"></mat-spinner>
</div>

